// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7159b473","455":"f7706c12","977":"409d1713"}[chunkId] + ".chunk.js";
};